<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-04-29 13:48:09
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-13 14:52:28
 * @FilePath: /dsicm-admin-web/src/views/newPatientmanage/components/UserDetails/userRight.vue
-->
<template>
    <div class="user-details">
        <div class="top">
            <strong>病历基本信息</strong>
            <div class="btn" @click="isEdit = !isEdit" v-if="!isEdit">
                <i class="el-icon-edit"></i>
                <p>编辑</p>
            </div>
            <div class="btn" @click="submitHandel" v-else>
                <i class="el-icon-edit"></i>
                <p>保存</p>
            </div>
        </div>
        <aside>
            <span v-show="false">{{getUserDetailsData}}</span>
            <el-scrollbar 
            style="height: 100%" 
            wrap-style="overflow-x:hidden;"
            >
                <el-form 
                  :model="ruleForm" 
                  :rules="rules"
                  label-width="140px"
                  size="mini"
                  ref="ruleForm" 
                  label-position="left"
                 >
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="当前状态:">
                                <p v-if="!isEdit">{{ruleForm.patientStatus == 1 ? '住院' : ruleForm.patientStatus == 2?'出院' :''}}</p>
                                <el-select v-model="ruleForm.patientStatus" v-else>
                                    <el-option 
                                    :label="item.label" 
                                    :value="item.value" 
                                    v-for="(item,index) in patientStatusList" 
                                    :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最近一次住院天数:">
                                <p v-show="ruleForm.hospitalizedNumber">{{ruleForm.hospitalizedNumber}}天</p>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="最近一次入院时间:">
                                <p v-if="!isEdit">{{ruleForm.hospitalStaysTime}}</p>
                                <el-date-picker
                                    v-else
                                    v-model="ruleForm.hospitalStaysTime"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    type="date"
                                    style="width:172px"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最近一次出院时间:" prop="bloodType">
                                <p v-if="!isEdit">{{ruleForm.hospitalDischargeTime}}</p>
                                <el-date-picker
                                    v-else
                                    v-model="ruleForm.hospitalDischargeTime"
                                    value-format="yyyy-MM-dd"
                                    :clearable="false"
                                    style="width:172px"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                   
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="在院期间是否进行手术:">
                                <p v-if="!isEdit">{{ruleForm.operationStatus == 1 ? '是' :'否' }}</p>
                                <el-select v-model="ruleForm.operationStatus" v-else>
                                    <el-option 
                                    :label="item.label" 
                                    :value="item.value" 
                                    v-for="(item,index) in operationStatusList" 
                                    :key="index">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="最近一次手术时间:">
                                <p v-if="!isEdit">{{ruleForm.operationTime}}</p>
                                <el-date-picker
                                    v-else
                                    v-model="ruleForm.operationTime"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    style="width:172px"
                                    :clearable="false"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                   
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="近期是否门诊就诊:" prop="outpatientStatus" :class="!isEdit ? 'asdsa':'' ">
                                <p v-if="!isEdit">{{ruleForm.outpatientStatus == 1 ? '是' : '否'}}</p>
                                <el-select v-model="ruleForm.outpatientStatus" v-else>
                                    <el-option 
                                    v-for="(item,index) in operationStatusList"
                                    :key="index"
                                    :label="item.label" 
                                    :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="门诊就诊时间:" prop="clinicTime" :class="!isEdit ? 'asdsa':'' ">
                                <p v-if="!isEdit">{{ruleForm.clinicTime}}</p>
                                <el-date-picker
                                    v-else
                                    v-model="ruleForm.clinicTime"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    style="width:172px"
                                    :clearable="false"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-form-item label="入院主要诊断:">
                            <p v-if="!isEdit">{{ruleForm.diagnosis}}</p>
                            <el-input
                            v-else
                            type="textarea"
                            clearable
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.diagnosis">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="入院次要诊断:">
                            <p v-if="!isEdit">{{ruleForm.hospitalizedSecondaryDiagnosis}}</p>
                            <el-input
                            v-else
                            :clearable="true"
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.hospitalizedSecondaryDiagnosis">
                            </el-input>
                        </el-form-item>
                    </el-row>

                     <el-row>
                        <el-form-item label="入院其他诊断:">
                            <p v-if="!isEdit">{{ruleForm.diagnosisOther}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.diagnosisOther">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="出院诊断:">
                            <p v-if="!isEdit">{{ruleForm.dischargeDiagnosis}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.dischargeDiagnosis">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="门诊主要诊断:" prop="outpatientPrincipalDiagnosis" :class="!isEdit ? 'asdsa':'' ">
                            <p v-if="!isEdit">{{ruleForm.outpatientPrincipalDiagnosis}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.outpatientPrincipalDiagnosis">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="门诊次要诊断:">
                            <p v-if="!isEdit">{{ruleForm.outpatientSecondaryDiagnosis}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.outpatientSecondaryDiagnosis">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="门诊其他诊断:">
                            <p v-if="!isEdit">{{ruleForm.outpatientOtherDiagnosis}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.outpatientOtherDiagnosis">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="门诊就诊科室:" prop="outpatientClinicDepartment" :class="!isEdit ? 'asdsa':'' ">
                            <p v-if="!isEdit">{{ruleForm.outpatientClinicDepartment}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.outpatientClinicDepartment">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="病人主诉:" prop="chiefComplaint" :class="!isEdit ? 'asdsa':'' ">
                            <p v-if="!isEdit">{{ruleForm.chiefComplaint}}</p>
                            <el-input
                            v-else
                            clearable
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.chiefComplaint">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="现病史:" prop="historyPresentIllness" :class="!isEdit ? 'asdsa':'' ">
                            <p v-if="!isEdit">{{ruleForm.historyPresentIllness}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.historyPresentIllness">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="既往史:">
                            <p v-if="!isEdit">{{ruleForm.pastMedical}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.pastMedical">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="个人史:">
                            <p v-if="!isEdit">{{ruleForm.personalHistory}}</p>
                            <el-input
                            v-else
                            clearable
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.personalHistory">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-form-item label="手术史:">
                        <p v-if="!isEdit">{{ruleForm.operationHistory}}</p>
                        <el-input
                        v-else
                        clearable
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 3 }"
                        resize="none"
                        placeholder="请输入内容"
                        v-model="ruleForm.operationHistory">
                        </el-input>
                    </el-form-item>
                    
                    <el-row>
                        <el-form-item label="婚育史、月经史:">
                            <p v-if="!isEdit">{{ruleForm.obstericalHistory}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.obstericalHistory">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="家族史:">
                            <p v-if="!isEdit">{{ruleForm.geneticHistory}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.geneticHistory">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="出院记录:">
                            <p v-if="!isEdit">{{ruleForm.leaveHospitalRecord}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.leaveHospitalRecord">
                            </el-input>
                        </el-form-item>
                    </el-row>

                    <el-row>
                        <el-form-item label="备注:">
                            <p v-if="!isEdit">{{ruleForm.remark}}</p>
                            <el-input
                            clearable
                            v-else
                            type="textarea"
                            :autosize="{ minRows: 2, maxRows: 3 }"
                            resize="none"
                            placeholder="请输入内容"
                            v-model="ruleForm.remark">
                            </el-input>
                        </el-form-item>
                    </el-row>

                </el-form>
            </el-scrollbar>
        </aside>
    </div>
</template>

<script>
import {UpdatepatientArchiesRight} from '../../api'
export default {
    name:'UserDetails',
    props:{
        userDetailsData:{
            type:Object,
            default:()=>{}
        }
    },
    data(){
        return{
            ruleForm:{
                patientStatus:'',//	当前状态 1住院 2出院
                hospitalizedNumber:'',//最近一次住院天数:
                hospitalStaysTime:'',//	最近一次入院时间
                hospitalDischargeTime:'',//	最近一次出院时间
                operationStatus:'',//	在院期间是否进行手术 1 是 2 否
                operationTime:'',//最近一次手术时间	
                outpatientStatus:'',//	近期是否门诊就诊 1 是 2 否
                clinicTime:'',//	门诊就诊时间
                diagnosis:"",//	入院主要诊断
                hospitalizedSecondaryDiagnosis:"",//	入院次要诊断
                diagnosisOther:'',//	入院其他诊断
                dischargeDiagnosis:'',//	出院诊断
                outpatientPrincipalDiagnosis:'',//	门诊主要诊断
                outpatientSecondaryDiagnosis:'',//	门诊次要诊断
                outpatientOtherDiagnosis:'',//	门诊其他诊断
                outpatientClinicDepartment:'',//	门诊就诊科室
                chiefComplaint:'',//	主诉
                historyPresentIllness:'',//	现病史 
                pastMedical:'',//	既往史
                personalHistory:'',//	个人史
                operationHistory:'',//手术史
                obstericalHistory:'',//	婚育史/月经史
                geneticHistory:'',//	家族病史
                leaveHospitalRecord:'',//	出院记录
                remark:'',//	个案备注
                id:'',//	id
            },
            rules:{
                clinicTime:[
                    { required: true, message: '请选择门诊就诊时间：', trigger: 'change' }
                  
                ],
                outpatientStatus: [
                    { required: true, message: '请选择近期是否门诊就诊：', trigger: 'change' }
                ],
                outpatientPrincipalDiagnosis: [
                    { required: true, message: '请输入门诊主要诊断：', trigger: 'blur' },
                ],
                outpatientClinicDepartment: [
                    { required: true, message: '请输入门诊就诊科室：', trigger: 'blur' },
                ],
                chiefComplaint: [
                    { required: true, message: '请输入病人主诉：', trigger: 'blur' },
                ],
                historyPresentIllness: [
                    { required: true, message: '请输入现病史：', trigger: 'blur' },
                ],
            },//输入规则
            isEdit:false,//false 为编辑 true 为保存
            patientStatusList:[
                {
                    label:'住院',
                    value:1
                },
                {
                    label:'出院',
                    value:2
                },
            ],
            operationStatusList:[
                {
                    label:'是',
                    value:1
                },
                {
                    label:'否',
                    value:2
                },
            ]
        }
    },

    computed:{
        getUserDetailsData(){
            if(!this.userDetailsData) return false;

            Object.keys(this.ruleForm).forEach(item=>{
                this.ruleForm[item] = this.userDetailsData[item] || ''
            })
            return this.ruleForm
        }
    },

    // watch:{
    //     userDetailsData:{
    //         deep:true,
    //         immediate:true,
    //         handler(newVal,oldVal){
    //             Object.keys(this.ruleForm).forEach(item=>{
    //                 this.ruleForm[item] = newVal[item] || ''
    //             })
    //         }
    //     }
    // },

    methods:{
        
        /**
         * @description: 保存按钮
         * @param {*}
         * @return {*}
         */    
        submitHandel(){
            if(!this.ruleForm.outpatientStatus) return this.$message.error('请选择近期是否门诊就诊');
            if(!this.ruleForm.clinicTime) return this.$message.error('请选择就诊时间');
            if(!this.ruleForm.outpatientPrincipalDiagnosis) return this.$message.error('请填写门诊主要诊断');
            if(!this.ruleForm.outpatientClinicDepartment) return this.$message.error('请填写门诊就诊科室');
            if(!this.ruleForm.chiefComplaint) return this.$message.error('请填写主诉');
            if(!this.ruleForm.historyPresentIllness) return this.$message.error('请填写现病史');
            if(!this.ruleForm.outpatientStatus) return this.$message.error('请填写个人史');
            if(this.isEdit){
                UpdatepatientArchiesRight(this.ruleForm).then(res=>{
                    if(res.code == 0 ){
                        this.$message.success('修改成功')
                        this.isEdit = false
                    }else{
                        this.$message.error(res.message)
                    }
                }).catch(error=>{
                    this.$message.error(error.message)
                })
            }
        }
    },
}
</script>
<style scoped lang="less">
@import './index.less';
</style>